module.exports = __webpack_public_path__ + "static/media/2025_Tusass.f81c6817.png";